import { ChannelHeader } from './ChannelHeader';
import { SignalFile } from './SignalFile';
import SignalFileHeader from './SignalFileHeader';
import SignalReadableContents from './SignalReadableContents';

export default class SignalFileReader {
  private contents: SignalReadableContents;

  private constructor(buffer: ArrayBuffer, private readonly header?: SignalFileHeader) {
    this.contents = new SignalReadableContents(buffer);
  }

  static create(data: ArrayBuffer, header: SignalFileHeader) {
    return new SignalFileReader(data, header);
  }

  static createWithFile(file: ArrayBuffer) {
    return new SignalFileReader(file);
  }

  private readSignalRecords(channelHeaders: ChannelHeader[], dataRecordLength: number) {
    const signalRecords: number[][] = Array.from({ length: channelHeaders.length }, () => []);

    for (let drl = 0; drl < dataRecordLength; drl++) {
      for (let ch = 0; ch < channelHeaders.length; ch++) {
        const { samples } = channelHeaders[ch];
        for (let smp = 0; smp < samples; smp++) {
          let signal: number;

          if (this.contents.isBdf()) {
            signal = this.contents.readInt24LE();
          } else {
            signal = this.contents.readInt16LE();
          }

          signalRecords[ch].push(signal);
        }
      }
    }
    return signalRecords;
  }

  read(): SignalFile {
    const signalFileHeader = this.header ?? SignalFileHeader.parseHeader(this.contents);
    console.log(signalFileHeader.fileHeader);
    console.log(signalFileHeader.channelHeaders);
    const signalFile = new SignalFile(signalFileHeader);

    const signalRecords = this.readSignalRecords(signalFile.channelHeaders, signalFile.header.dataRecordCnt);
    console.log(signalRecords);

    signalFile.setSignalRecords(signalRecords);
    return signalFile;
  }
}
